
<div class="card-container m-b-20">

    <div class="card-summary-title flex flex-horiz-space-bw">
      <h3 class="heading"><i nz-icon nzType="user"></i> My Inbox</h3>
      <nz-button-group>
        <button *ngIf="!cardCollapsed" nz-button class="b-0" (click)="cardCollapsed=!cardCollapsed"><i nz-icon nzType="edit"></i>Advanced Search</button>
      </nz-button-group>
    </div>

    <div class="card-summary" *ngIf="!cardCollapsed">
      <div class="card-summary-content">
        <div class="card-summary-data-grid">
          <div class="card-summary-data">
            <b>Product:</b>
            <!--<nz-avatar nzIcon="user" nzSrc="https://randomuser.me/api/portraits/women/17.jpg"></nz-avatar>-->
            HealthFirst
          </div>
          <div  class="card-summary-data">
            <b>Plan:</b> Silver
          </div>
          <!-- <div class="card-summary-data">
            <b>Currency:</b> BMW
          </div> -->
          <div class="card-summary-data">
            <b>Purpose of Insurance:</b> Protection
          </div>
          <!-- <div class="card-summary-data">
            <b>Entry Date:</b> Sep 4, 2019
          </div> -->
          <!-- <div class="card-summary-data">
            <b>Received Date:</b> Sep 4, 2019
          </div> -->
          <!-- <div class="card-summary-data">
            <b>Signed Date:</b> Sep 4, 2019
          </div> -->
          <div class="card-summary-data">
            <b>Inception Date:</b> Sep 4, 2019
          </div>
          <div class="card-summary-data">
            <b>Expiry Date:</b> Sep 4, 2019
          </div>
          <!-- <div class="card-summary-data">
            <b>Due Date:</b> Sep 4, 2019
          </div> -->

          <!-- <div class="card-summary-data">
            <b>Summary:</b> Yes
          </div> -->
        </div>
      </div>
      <!-- <div class="card-summary-actions">
        <a href="javascript:void(0)" (click)="cardCollapsed=!cardCollapsed">
          <i nz-icon nzType="edit"></i>
        </a>
      </div> -->
    </div>

    <form *ngIf="cardCollapsed">
      <div>

        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Product</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                <nz-option nzValue="1" nzLabel="HealthFirst"></nz-option>
                <nz-option nzValue="0" nzLabel="HealthSecond"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Plan</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                <nz-option nzValue="1" nzLabel="Gold"></nz-option>
                <nz-option nzValue="0" nzLabel="Silver"></nz-option>
                <nz-option nzValue="0" nzLabel="Platinum"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <!-- <nz-form-item>
                  <nz-form-label [nzSpan]="24">Purpose of Insurance</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                      <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                          <nz-option nzValue="1" nzLabel="Protection"></nz-option>
                          <nz-option nzValue="0" nzLabel="Credit Terms"></nz-option>
                      </nz-select>
                  </nz-form-control>
              </nz-form-item> -->
          <div></div>

        </div>

        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Purpose of Insurance</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group nzName="radiogroup" [(ngModel)]="purposeValue" name="radiogroup">
                <label nz-radio nzValue="A">Protection</label>
                <label nz-radio nzValue="B">Credit Terms</label>
                <label nz-radio nzValue="C">Safety and Convinience</label>
                <label nz-radio nzValue="D">Others</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Currency</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group nzName="radiogroup" [(ngModel)]="productcurrency" name="radiogroup">
                <label nz-radio nzValue="A">USD</label>
                <label nz-radio nzValue="B">INR</label>
                <label nz-radio nzValue="C">IDR</label>
                <label nz-radio nzValue="D">SGD</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>


        <div class="flexie-auto-grid">

          <!-- <nz-form-item>
                <nz-form-label [nzSpan]="24">Currency</nz-form-label>
                <nz-form-control [nzSpan]="24">
                    <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                        <nz-option nzValue="1" nzLabel="USD"></nz-option>
                        <nz-option nzValue="0" nzLabel="INR"></nz-option>
                        <nz-option nzValue="0" nzLabel="IDR"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item> -->

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Inception Date and Expiry Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-range-picker name="daterange" [(ngModel)]="dateRange" (ngModelChange)="onChange($event)" nzShowTime></nz-range-picker>
            </nz-form-control>
          </nz-form-item>
          <div></div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Due Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>



        </div>

        <div class="flexie-auto-grid">

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Entry Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Received Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Signed Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

        </div>

      </div>
      <div class="card-summary-data-footer">
        <div>
          <button nz-button (click)="cardCollapsed=!cardCollapsed">Cancel</button>
        </div>
        <div>
          <button nz-button class="b-0 m-r-10" (click)="cardCollapsed=!cardCollapsed">Cancel</button>
          <button nz-button [nzType]="'primary'" (click)="cardCollapsed=!cardCollapsed">Save</button>
        </div>
      </div>
    </form>

  </div>
<div nz-row class="flex flex-dir-vert flex-horiz-space-bw">
  <!-- <h2>My Inbox </h2> -->

  <div>
    <!--
        <nz-input-group>
        <nz-select nzShowSearch  style="width: 70px;">
          <nz-option nzLabel="+86" nzValue="+86"></nz-option>
          <nz-option nzLabel="+87" nzValue="+87"></nz-option>
        </nz-select>
        <input id="'phoneNumber'" nz-input>
        </nz-input-group>
    -->
  </div>

  <div class="ta-right">
    <!--<nz-range-picker style="align-self: flex-end; margin-top: -30px"
     [nzShowTime]="{ nzFormat: 'HH:mm' }"
     nzFormat="yyyy-MM-dd HH:mm"
     [nzPlaceHolder]="[ 'Start Time', 'End Time' ]"
     data-ngModelChange="onChange($event)"
     data-nzOnOk="onOk($event)"
    >
    </nz-range-picker>-->
    <div class="m-b-20">
      <!--
            <b>My Tasks</b>
            <nz-divider nzType="vertical"></nz-divider>
            <a href="javascript:void(0)">Subordinate Tasks</a>
            <nz-divider nzType="vertical"></nz-divider>
            <a href="javascript:void(0)">Team Tasks</a>
      -->
      <nz-radio-group [(ngModel)]="radioValue" [nzButtonStyle]="'solid'" [nzSize]="'default'">
        <label nz-radio-button nzValue="myCases" (click)="randomizeList()"><i nz-icon nzType="user" nzTheme="outline"></i> My Tasks</label>
        <label nz-radio-button nzValue="subTasks" (click)="randomizeList()"><i nz-icon nzType="usergroup-add" nzTheme="outline"></i> Subordinate Tasks</label>
        <label nz-radio-button nzValue="teamTasks" (click)="randomizeList()"><i nz-icon nzType="team" nzTheme="outline"></i> Team Tasks</label>
      </nz-radio-group>

      <nz-form-control [nzSpan]="6" style="float:right"> 
          <input nz-input placeholder="Search" name="input-basic"/>
      </nz-form-control>
    </div>
  </div>
</div>

<!--

<div class="m-t-b-20">
  <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
    <nz-timeline>

      <nz-timeline-item nzColor="blue">
        <p>
          <b>Data entry	 </b>
          <br>
          Completed at: 20 Nov 2018 (3 days ago)
          <br>
          Assigned to: <nz-avatar nzSize="small" nzIcon="anticon anticon-user"
                                  nzSrc="https://randomuser.me/api/portraits/women/32.jpg"></nz-avatar> Synthia Mariam
          <nz-tag [nzColor]="'blue'">11:20 AM</nz-tag>
        </p>
      </nz-timeline-item>

      <nz-timeline-item nzColor="blue">
        <p>
          <b>Case auto issuance </b>
          <br>
          Completed at: 20 Nov 2018 (3 days ago)
          <br>
          Assigned to: <nz-avatar nzSize="small" nzIcon="anticon anticon-user"
                                  nzSrc="https://randomuser.me/api/portraits/women/15.jpg"></nz-avatar> Lina Rebecca
          <nz-tag [nzColor]="'blue'">11:20 AM</nz-tag>
        </p>
      </nz-timeline-item>

    </nz-timeline>
  </div>
</div>
-->


<div nz-row *ngFor="let item of list; index as i">

  <div nz-col nzSpan="24" class="task-item shadowed-on-hover">

    <nz-skeleton [nzAvatar]="true" [nzActive]="true" [nzTitle]="true" [nzLoading]="isLoading">

      <div class="task-item-grid">
        <div>
          <div class="task-item-block">
            <b><i nz-icon nzType="car" nzTheme="outline"></i> {{item.baseProductFamilyCd}}: {{item.proposalNum}} </b>
          </div>
          <div class="task-item-block">
            Sum Insured: IDR 572.000.000,00 &bull; Premium: IDR  6.894.000,00
          </div>
          <div class="task-item-block">
            {{item.makeDesc}} &bull; 1.4 TSFi
          </div>
          <div class="task-item-block">
            Primary Insured:
            <nz-avatar nzSize="small" nzIcon="anticon anticon-user" nzSrc="https://randomuser.me/api/portraits/men/{{i}}.jpg"></nz-avatar>
            John Remi
          </div>
        </div>

        <div>
          SLA: <nz-tag [nzColor]="'#f50'">Expired</nz-tag>
          <br>
          Complexity: 8
          <br>
          Priority: 5
        </div>

        <div>
          <button nz-button nzType="primary" class="w-100-pc b-r-0" (click)="item.isCollapsed=!item.isCollapsed"><i nz-icon nzType="safety" nzTheme="outline"></i> Analyze</button>
          <button nz-button nzType="default" class="w-100-pc b-r-0"><i nz-icon nzType="eye" nzTheme="outline"></i> Open</button>
        </div>
      </div>

      <div *ngIf="item.isCollapsed">

        <div nz-row style="margin:20px auto;">

          <div nz-col nzXs="24" >
            <div nz-row>

              <h2>ML Analysis for Case {{item.proposalNum}}</h2>

              <div nz-col nzSpan="8">
                <div class="widget-small-analytics">
                  <div class="content">
                    <div nz-row>
                      <div nz-col nzSpan="18">
                        <div class="numbers">
                          <p>Risk <span>score</span></p>
                          <strong class="color-danger">36</strong>
                        </div>
                      </div>
                      <div nz-col nzSpan="6">
                        <div class="icon-big icon-warning text-center">
                          <img src="/assets/images/ico/prob-risk.png" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="widget-small-footer">
                      <div class="stats">
                        Assessment: <strong class="color-danger">Attention</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div nz-col nzSpan="8">
                <div class="widget-small-analytics">
                  <div class="content">
                    <div nz-row>
                      <div nz-col nzSpan="18">
                        <div class="numbers">
                          <p>Claim <span>probability</span></p>
                          <strong class="color-warning">26%</strong>
                        </div>
                      </div>
                      <div nz-col nzSpan="6">
                        <div class="icon-big icon-warning text-center">
                          <img src="/assets/images/ico/prob-claim.png" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="widget-small-footer">
                      <div class="stats">
                        Assessment: <strong class="color-warning">Caution</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div nz-col nzSpan="8">
                <div class="widget-small-analytics">
                  <div class="content">
                    <div nz-row>
                      <div nz-col nzSpan="18">
                        <div class="numbers">
                          <p>Fraud <span>probability</span></p>
                          <strong class="color-safe">12%</strong>
                        </div>
                      </div>
                      <div nz-col nzSpan="6">
                        <div class="icon-big icon-warning text-center">
                          <img src="/assets/images/ico/prob-fraud.png" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="widget-small-footer">
                      <div class="stats">
                        Assessment: <strong class="color-safe">Safe</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">

            <h4 class="decision-list-head"><strong class="color-pc">Recommended</strong> action</h4>

            <div class="decision-item-highlight">
              <div><h2 class="color-safe">Approve with premium increase</h2>
                <p>
                  Based on leanings from auto-underwriting rule results and your previous case decisions
                  <!--<a href="">More details &rarr;</a>-->
                </p>
              </div>
            </div>

          </div>

          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">

            <h4 class="decision-list-head">Auto-Underwriting <strong class="color-pc">analysis</strong></h4>

            <div class="decisions-list">

              <div class="decision-item decision-item-three color-danger">
                <strong>Vehicle is a private vehicle</strong>
                <span>High</span>
                <span>Failed</span>
              </div>

              <div class="decision-item decision-item-three color-danger">
                <strong>Car is non-sports/non-luxury</strong>
                <span>High</span>
                <span>Failed</span>
              </div>

              <div class="decision-item decision-item-three color-safe">
                <span>Car is a brand new car</span>
                <span>High</span>
                <span>Passed</span>
              </div>

              <div class="decision-item decision-item-three color-safe">
                <span>Car is not older than 15 years</span>
                <span>Medium</span>
                <span>Passed</span>
              </div>

            </div>

          </div>

          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
            <h4 class="decision-list-head">Decisions taken <strong class="color-blue">by you</strong> for similar cases</h4>
            <div class="decisions-list">
              <div class="decision-item">
                <span>Accepted with premium increase</span>
                <div>
                          <span class="progress-bar-simple">
                              <span class="progress-bar-simple-text">36%</span>
                              <span class="progress-bar-simple-perc" style="width:36%"></span>
                          </span>
                </div>
              </div>
              <div class="decision-item">
                <span>Accepted with more documents</span>
                <div>
                          <span class="progress-bar-simple">
                              <span class="progress-bar-simple-text">23%</span>
                              <span class="progress-bar-simple-perc" style="width:23%"></span>
                          </span>
                </div>
              </div>
              <div class="decision-item">
                <span>Rejected without additional reason</span>
                <div>
                          <span class="progress-bar-simple">
                              <span class="progress-bar-simple-text">19%</span>
                              <span class="progress-bar-simple-perc" style="width:19%"></span>
                          </span>
                </div>
              </div>
              <div class="decision-item">
                <span>Rejected with reason</span>
                <div>
                          <span class="progress-bar-simple">
                              <span class="progress-bar-simple-text">11%</span>
                              <span class="progress-bar-simple-perc" style="width:11%"></span>
                          </span>
                </div>
              </div>
            </div>
          </div>

          <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
            <h4 class="decision-list-head">Decisions taken <strong class="color-blue">by others</strong> for similar cases</h4>
            <div class="decisions-list">
              <div class="decision-item">
                <span>Accepted with more documents</span>
                <div>
                          <span class="progress-bar-simple">
                              <span class="progress-bar-simple-text">42%</span>
                              <span class="progress-bar-simple-perc" style="width:42%"></span>
                          </span>
                </div>
              </div>
              <div class="decision-item">
                <span>Accepted with premium increase</span>
                <div>
                          <span class="progress-bar-simple">
                              <span class="progress-bar-simple-text">22%</span>
                              <span class="progress-bar-simple-perc" style="width:22%"></span>
                          </span>
                </div>
              </div>
              <div class="decision-item">
                <span>Rejected without additional reason</span>
                <div>
                          <span class="progress-bar-simple">
                              <span class="progress-bar-simple-text">11%</span>
                              <span class="progress-bar-simple-perc" style="width:11%"></span>
                          </span>
                </div>
              </div>
              <div class="decision-item">
                <span>Rejected with reason</span>
                <div>
                          <span class="progress-bar-simple">
                              <span class="progress-bar-simple-text">8%</span>
                              <span class="progress-bar-simple-perc" style="width:8%"></span>
                          </span>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

      <div class="task-item-foot">
        <span>Created Date: 03 Jul 2018 (3 days ago)</span>
        <span>Last Re-assigned by: Mathew Perry (Manager)</span>
        <span>Assigned to: John Smith (You)</span>
      </div>

    </nz-skeleton>

  </div>

</div>


<nz-drawer [nzVisible]="details" [nzWidth]="640" [nzClosable]="true" (nzOnClose)="close()">

  <h2><nz-avatar class="m-r-5" nzSize="large" nzIcon="anticon anticon-user"
                 nzSrc="https://randomuser.me/api/portraits/women/15.jpg"></nz-avatar> Lina Rebecca </h2>

  <p class="draw-user-title">Personal</p>

  <div nz-row>

    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Full Name:</p>Lily
      </div>
    </div>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Account:</p>AntDesign@example.com
      </div>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">City:</p>HangZhou
      </div>
    </div>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Country:</p>China🇨🇳
      </div>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Birthday:</p>February 2, 1990
      </div>
    </div>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Age:</p>
      </div>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Message:</p>Make things as simple as possible but no simpler.
      </div>
    </div>
  </div>
  <nz-divider></nz-divider>
  <p class="draw-user-title">Company</p>
  <div nz-row>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Position:</p>Programmer
      </div>
    </div>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Responsibilities:</p>Coding
      </div>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Department:</p>AFX
      </div>
    </div>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Supervisor:</p>
        <a>Lin</a>
      </div>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Skills:</p>C / C + +, data structures, software engineering, operating systems, computer networks, databases, compiler theory, computer architecture, Microcomputer Principle and Interface Technology, Computer English, Java, ASP, etc.
      </div>
    </div>
  </div>
  <nz-divider></nz-divider>
  <p class="draw-user-title">Contacts</p>
  <div nz-row>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Email:</p>AntDesign@example.com
      </div>
    </div>
    <div nz-col nzSpan="12">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Phone Number:</p>+86 181 0000 0000
      </div>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="24">
      <div class="draw-user-item-wrap">
        <p class="draw-user-label">Github:</p>
        <a href="https://github.com/NG-ZORRO/ng-zorro-antd" target="_blank">github.com/NG-ZORRO/ng-zorro-antd</a>
      </div>
    </div>
  </div>
</nz-drawer>

<!--<nz-list
        [nzDataSource]="list"
        [nzItemLayout]="'vertical'"
        [nzRenderItem]="item"
        [nzPagination]="pagination">
  <ng-template #item *ngFor="let item of list">
    <nz-list-item [nzContent]="item.proposalNum" [nzActions]="[starAction,likeAction,msgAction]" [nzExtra]="extra">
      <ng-template #starAction><i nz-icon nzType="star-o" style="margin-right: 8px;"></i> 156</ng-template>
      <ng-template #likeAction><i nz-icon nzType="like-o" style="margin-right: 8px;"></i> 156</ng-template>
      <ng-template #msgAction><i nz-icon nzType="message" style="margin-right: 8px;"></i> 2</ng-template>
      <nz-list-item-meta
              [nzAvatar]="item.proposalNum"
              [nzTitle]="nzTitle"
              [nzDescription]="item.proposalNum">
        <ng-template #nzTitle><a href="{{item.proposalNum}}">{{item.proposalNum}}</a></ng-template>
      </nz-list-item-meta>
      <ng-template #extra>
        <img width="272" alt="logo" src="https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png">
      </ng-template>
    </nz-list-item>
  </ng-template>
  <ng-template #pagination>
    <nz-pagination [nzPageIndex]="1" [nzTotal]="50"></nz-pagination>
  </ng-template>
</nz-list>-->
